import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Tabs,
  Tab
} from "@material-ui/core";
import styled from "styled-components";
import { withTranslation } from "react-i18next";

const PayloadPre = styled.pre`
  margin: 0;
  padding: 16px;
  background-color: #f5f5f5;
  border-radius: 4px;
  font-family: "Roboto Mono", monospace;
  font-size: 13px;
  overflow: auto;
  max-height: 60vh;
  white-space: pre-wrap;
  word-break: break-word;
`;

const hasContent = value => {
  if (value == null) return false;
  if (typeof value === "string") return value.length > 0;
  if (typeof value === "object") return Object.keys(value).length > 0;
  return true;
};

const formatContent = value => {
  if (typeof value === "string") return value;
  return JSON.stringify(value, null, 2);
};

class JobPayloadDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0
    };
  }

  componentDidUpdate(prevProps) {
    const { open } = this.props;
    if (prevProps.open && !open) {
      this.setState({ activeTab: 0 });
    }
  }

  handleTabChange = (_event, activeTab) => {
    this.setState({ activeTab });
  };

  render() {
    const { open, onClose, payload, response, title, t } = this.props;
    const { activeTab } = this.state;
    const content = activeTab === 0 ? payload : response;
    const emptyMessage =
      activeTab === 0 ? t("jobs.payload.empty") : t("jobs.payload.noResponse");

    return (
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>{title || t("jobs.payload.title")}</DialogTitle>
        <Tabs
          value={activeTab}
          onChange={this.handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label={t("jobs.payload.sentTab")} />
          <Tab label={t("jobs.payload.responseTab")} />
        </Tabs>
        <DialogContent>
          <PayloadPre>
            {hasContent(content) ? formatContent(content) : emptyMessage}
          </PayloadPre>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            {t("common.actions.close")}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

JobPayloadDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  payload: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  response: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string,
  t: PropTypes.func.isRequired
};

JobPayloadDialog.defaultProps = {
  payload: null,
  response: null,
  title: ""
};

export default withTranslation()(JobPayloadDialog);
